/* Release flags for the first live run of CS 140.
 *
 * These are NOT pedagogy and NOT the progress gating in lib/gating.js. They are
 * a release valve: the course content is complete, the polish pass is not, and
 * the term starts before the polish finishes. Everything here is meant to be
 * turned on and then deleted.
 *
 * Each flag says what has to be true before it can be flipped.
 */

/** Language tracks a student may choose.
 *
 *  Turn on when: the `python` and `ruby` track blocks have been written and
 *  reviewed for every lesson. Today only `js` is complete — 33 lessons carry a
 *  `:::track js`, and the other tracks are partial. Offering a half-written
 *  track is worse than offering one.
 *
 *  Note the content tree also has `csharp` blocks; `TRACKS` never listed it.
 *  Whichever ship, this list is what the picker offers. */
export const LANGUAGES = ['js'];

/** Publishes every module up to and including this one, in teaching order
 *  (the order of `modules:` in content/cs140/course.yml) — whole modules,
 *  never half of one. Orientation is always published. `'final'` adds the
 *  final checkpoint; `null` publishes everything.
 *
 *  Move it forward one module as Nick finishes reviewing each (D-059). Dates
 *  play no part: a module's start date, its homework's due date and the
 *  course home's highlight never publish or hide anything. This is a
 *  *release* gate, not a pace gate, and once the course is reviewed it
 *  becomes `null`. */
export const PUBLISHED_THROUGH_MODULE = 'arrays';

/** Progress tracking: "Mark complete", the progress meter, stored state.
 *
 *  Turn on when: there is a way to identify a student and somewhere to keep
 *  their state. Today it is localStorage only — per browser, per device, lost
 *  on a cache clear, and invisible to an instructor — which reads as a promise
 *  the site cannot keep. Canvas remains the system of record for anything that
 *  counts toward a grade. */
export const PROGRESS_ENABLED = false;

/** The cohort currently being taught.
 *
 *  Update these two dates each term. They drive the "where are we" panel on
 *  the course home — the week of the quarter and how long is left — which is
 *  the only thing on the site that knows a cohort exists.
 *
 *  Fall 2026: Monday 28 September to Wednesday 16 December. That is 79 days,
 *  eleven weeks plus three, so the last few days fall inside week 11 — which
 *  is the final checkpoint, and correct.
 */
export const TERM = {
  start: '2026-09-28',
  end: '2026-12-16',
  name: 'Fall 2026',
};
